import { useKindeFeatureFlags, useTranslation } from "@next-platform/client-common-core";
import { IconVariants } from "@next-platform/client-common-spicy-ui";
import { useEffect } from "react";
import { useSortBy } from "react-instantsearch";

import { TYPESENSE_TEXT_MATCH_SORT_PREFIX } from "@/constants";
import { Collection } from "@/types/api";

import Dropdown from "../common/Dropdown";
import getLorebookExploreSortItems from "./getLorebookExploreSortItems";
import getRulebookExploreSortItems from "./getRulebookExploreSortItems";
import { SearchBySortProps } from "./types";

export default function SearchBySort({ baseIndexName, currentRefinement, setCurrentCategory, collection }: SearchBySortProps) {
  const { hasAccessToV2 } = useKindeFeatureFlags();
  const { t } = useTranslation();
  let sortItems = [];

  if (collection === Collection.RULEBOOKS) {
    sortItems = getRulebookExploreSortItems({
      collectionName: baseIndexName,
      textMatchPrefix: TYPESENSE_TEXT_MATCH_SORT_PREFIX,
      translate: t,
    });
  } else if (collection === Collection.LOREBOOKS) {
    sortItems = getLorebookExploreSortItems({
      collectionName: baseIndexName,
      textMatchPrefix: TYPESENSE_TEXT_MATCH_SORT_PREFIX,
      translate: t,
    });
  } else {
    sortItems = [
      { value: `${baseIndexName}/sort/${TYPESENSE_TEXT_MATCH_SORT_PREFIX},num_messages_24h:desc`, label: t("search:sortBy.trending") },
      { value: `${baseIndexName}/sort/${TYPESENSE_TEXT_MATCH_SORT_PREFIX},rating_score:desc`, label: t("search:sortBy.topRated") },
      { value: `${baseIndexName}/sort/${TYPESENSE_TEXT_MATCH_SORT_PREFIX},num_messages:desc`, label: t("search:sortBy.popular") },
      { value: `${baseIndexName}/sort/${TYPESENSE_TEXT_MATCH_SORT_PREFIX},createdAt:desc`, label: t("search:sortBy.latest") },
    ];
  }

  const sortByProps = { items: sortItems, initialIndex: currentRefinement };
  const { currentRefinement: currentRefinementSortBy, options, refine: refineSortBy } = useSortBy(sortByProps);

  const getLabel = (value: string) => {
    const option = options.find((option) => option.value === value);
    return option ? option.label : null;
  };

  const sortByOptions = options.map((option) => ({
    ...option,
    onPress: () => {
      refineSortBy(option.value);
    },
  }));

  useEffect(() => {
    setCurrentCategory((getLabel(currentRefinementSortBy) || "").toLowerCase().split(" ")?.join("_"));
  }, [currentRefinementSortBy]);

  return (
    <Dropdown
      currentValue={getLabel(currentRefinementSortBy)}
      listItems={sortByOptions}
      hasAccessToV2={hasAccessToV2}
      iconEnd={IconVariants.CHEVRON_DOWN}
    />
  );
}
